import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationDocument = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новый документ</div>
            <div className={'vm-notification__description'}>
                В базу добавлен новый документ <UiNavLink to={ROUTES.DOCUMENT_CATEGORY(notification.data.document.documentCategoryId)} onClick={onClose}>{notification.data.document.name}</UiNavLink>
            </div>
        </div>
    );
});
